
import { PETabs } from "@libs/useful"
import LoginForm from "./LoginForm"
import RegisterForm from "./RegisterForm" 
import { __ } from "@libs/utilities"
import { is_register } from "@libs/layouts"

/* Protopia Ecosystem component */
export interface ILoginRegisterMobileProps {
    extend_params?: any
}
const LoginRegisterMobile = (props: ILoginRegisterMobileProps): JSX.Element => {
    return  is_register() 
        ?
        <div className='pe-loginregistermobile-container'>
            <PETabs
                tabs={[
                    {
                        id: "register",
                        title: __("Create account"),
                        element: <RegisterForm {...props} />
                    },
                    {
                        id: "login",
                        title: __("Sign in"),
                        element: <LoginForm {...props} />
                    },
                ]}
                tabId="login"
            />
        </div>
        :
        <div className='pe-loginregistermobile-container'>
            <LoginForm {...props} />
        </div>
}
export default LoginRegisterMobile